import { Typography, styled } from '@mui/material';

const BaseTypography = styled(Typography)(() => ({
  fontWeight: 400,
  color: '#1D1D1D',
  letterSpacing: '0',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
}));

export const DisplaySmall = styled(BaseTypography)(({ theme }) => ({
  fontFamily: 'Ivar Display',
  fontSize: '42px',
  fontStyle: 'normal',
  lineHeight: '48px' /* 114.286% */,
  [theme.breakpoints.down('lg')]: {
    // Tablet
    fontSize: '36px',
    lineHeight: '42px' /* 116.667% */,
  },
  [theme.breakpoints.down('md')]: {
    // Mobile
    fontSize: '28px',
    lineHeight: '36px' /* 128.571% */,
  },
})) as typeof Typography;

export const HeaderLarge = styled(BaseTypography)(({ theme }) => ({
  fontSize: '24px',
  lineHeight: '36px',
  [theme.breakpoints.down('md')]: {
    fontSize: '20px',
    lineHeight: '28px',
  },
})) as typeof Typography;

export const HeaderExtraLarge = styled(BaseTypography)(({ theme }) => ({
  fontSize: '32px',
  lineHeight: '42px',
  [theme.breakpoints.down('md')]: {
    fontSize: '24px',
    lineHeight: '36px',
  },
})) as typeof Typography;

export const HeaderMedium = styled(BaseTypography)(({ theme }) => ({
  fontSize: '22px',
  lineHeight: '32px',
  [theme.breakpoints.down('md')]: {
    fontSize: '20px',
    lineHeight: '28px',
  },
})) as typeof Typography;

export const HeaderSmall = styled(BaseTypography)(({ theme }) => ({
  fontSize: '20px',
  lineHeight: '28px',
  [theme.breakpoints.down('md')]: {
    fontSize: '18px',
    lineHeight: '24px',
  },
})) as typeof Typography;

export const HeaderXSmall = styled(BaseTypography)(({ theme }) => ({
  fontSize: '16px',
  lineHeight: '26px',
  fontWeight: 600,
  [theme.breakpoints.down('md')]: {
    fontSize: '16px',
    lineHeight: '26px',
  },
}));

export const BodySmall = styled(BaseTypography)(({ theme }) => ({
  fontSize: '16px',
  lineHeight: '26px',
  color: '#4F4F4F',
  [theme.breakpoints.down('md')]: {
    fontSize: '16px',
    lineHeight: '26px',
  },
})) as typeof Typography;

export const BodyLarge = styled(BaseTypography)(({ theme }) => ({
  fontSize: '24px',
  lineHeight: '36px',
  [theme.breakpoints.down('md')]: {
    fontSize: '20px',
    lineHeight: '30px',
  },
})) as typeof Typography;

export const BodyMedium = styled(BaseTypography)(({ theme }) => ({
  fontSize: '20px',
  lineHeight: '30px',
  [theme.breakpoints.down('md')]: {
    fontSize: '18px',
    lineHeight: '28px',
  },
})) as typeof Typography;

export const BodyExtraSmall = styled(BaseTypography)(() => ({
  fontSize: '14px',
  lineHeight: '22px',
  color: '#4F4F4F',
})) as typeof Typography;

export const LabelSmall = styled(BaseTypography)(({ theme }) => ({
  fontSize: '12px',
  lineHeight: '20px',
  color: '#6D6D6D',
  [theme.breakpoints.down('md')]: {
    fontSize: '12px',
    lineHeight: '20px',
  },
})) as typeof Typography;
